import { Modal } from './components/architecture/frontend/index'
import { Amplify } from 'aws-amplify'
import awsconfig from './aws-exports';
import _ from 'lodash'

import NavBar from './components/NavBar'
import NewClaim from './components/Claim'
import AllClaims from './components/TableViews/AllClaims'
import AllShipments from './components/TableViews/AllShipments'
import ClaimsAwaitingReferee from './components/TableViews/AwaitingReferee'
import ClaimsRequiringPayment from './components/TableViews/RequiringPayment'
import IncompleteResults from './components/TableViews/IncompleteResults'
import ClaimsDenied from './components/TableViews/ClaimsDenied'
import SendToReferee from './components/TableViews/SendToReferee'
import PendingClaim from './components/TableViews/IncompleteClaim'
import Incomplete from './components/TableViews/IncompleteShipment'
import ExcelReport from './components/Reports/ExcelReport'
import ExcelAllClaimsReport from './components/Reports/ExcelAllClaims'
import PowerBIReports from './components/Reports/PowerBI'
import SendToSupplier from './components/TableViews/SendToSupplier'
import BaseEmailModal from './components/Modals/BaseEmailModal'
import SignIn from './components/SignIn'
import Header from './components/Header'
import GenericTable from './components/TableViews/GenericTable'
import TOS from './components/TOS'
import AccountSettings from './components/AccountSettings'
import Dashboard from './components/Dashboard'
import ShipmentSelection from './components/Modals/ShipmentSelection'
import ImportShipment from './components/Import'
import SimpleScanModal from './components/Claim/SimpleScan'
import AttachModal from './components/Claim/Attach'


Amplify.configure(awsconfig);

const ImportClaim = (props) => {
  return (
    <div className='w-100 pa4 '>
       <div className='fw7'>Claim Imports</div> <br/>

  This company is currently not setup for importing claims. Please contact Evonik or Corvia Tech to enable this feature.
    </div>
  )
}

// const ClaimsOverdue = (props) => {
//   return (
//           <div className='w-100 pa4 '>
//           <div className='fw7'>A table of claims that need to be paid and are now overdue </div> <br/>
//           This page would be similar to the "Requiring Payment" page but filtered to show only claims that are overdue.
//             {/* <br/><br/>
//             <span className='pointer blue fw7 underline' onClick={e => Dispatch.nextAction('view', 'claimNeedingShipment')}>Next Step</span> */}
//                   <br/><br/><br/>
//       <div className='fw7'>Questions:</div>
//       <br/>
//       Do overdue claims need a special process?
//       <br/><br/><br/>
//         <span className='pointer blue fw7 underline' onClick={e => Dispatch.nextAction('view', 'home')}>Home</span>
//         </div>
//   )
// }



function App(props) {
  const views = {
    receivingClaimsAwaitingPayment: IncompleteResults,
    receivingClaimsSendToSupplier: SendToSupplier,
    receivingClaimsNeedingInvoice: IncompleteResults,
    receivingClaimsNeedingResults: IncompleteResults,
    incompleteShipment:Incomplete,
    shipmentTable: AllClaims,
    importShipment: ImportShipment,
    newClaim: NewClaim,
    importClaim: ImportClaim,
    claimNeedingShipment: PendingClaim,
    claimSendToReferee: SendToReferee,
    claimsRequiringPayment: ClaimsRequiringPayment,
    claimsAwaitingReferee: ClaimsAwaitingReferee,
    claimsDenied: ClaimsDenied,
    claimTable: AllClaims,
    excelReport: ExcelReport,
    excelAllClaimsReport: ExcelAllClaimsReport,
    powerBIReports: PowerBIReports,
    // claimsOverdue: ClaimsOverdue,
    table: GenericTable,
    tos: TOS,
    accountSettings: AccountSettings,
  }
  const View = views[props.view?.type] ?? Dashboard
  const sidebarWidth = 240
  const modalChildren = {
    email: BaseEmailModal,
    shipmentSelect: ShipmentSelection,
    simpleScan: SimpleScanModal,
    attach: AttachModal
  }
  return (
    <div className="w-100 vh-100 avenir overflow-hidden">
      <Modal shouldCloseOnOverlayClick={true} _className={props.modal?.type === 'simpleScan' || props.modal?.type === 'attach' ? 'mw7 w-90 vh-95' : ''} _children={modalChildren} _style={{overlay: {backgroundColor: 'rgb(0,0,0,.3)'}}} { ...props } />
      {(_.isNil(props.user?.state) || props.user?.state !== 'signedin') ? 
        <SignIn />
      :
      <>
      <Header _sidebarWidth={sidebarWidth} {...props}/>
      <div className="w-100 vh-100 bg-white flex justify-between" >
        {/* Sidebar */}
        <div className='flex flex-column'>
          <NavBar _sidebarWidth={sidebarWidth} {...props}/>
        </div>
        {/* Main */}
        <div className='w-100 vh-100 mr2 pb2' style={{}}>
          <View {...props}/>
        </div>
      </div>
      </>
    }
    </div>
  );
}

export default App;
